// Additional authored Sales copy, including the shared WhatsApp page.
export const supplementArabicTranslations: Record<string, string> = {
  "Edit Course Assignment": "تعديل توزيع الكورس",
  "Consultation Bridge": "ربط مواعيد الاستشارة",
  "Lead Engagement": "التواصل مع العميل",
  "Proposal": "العرض",
  "Customer Snapshot": "ملخص العميل",
  "Courses & Offer Readiness": "الكورسات وجاهزية العرض",
  "course(s)": "كورس",
  "Referral": "الإحالة",
  "Registration Link": "رابط التسجيل",
  "Ready to Enroll": "جاهز للالتحاق",
  "Extra Receipt": "إيصال إضافي",
  "All Courses Have Invoices": "كل الكورسات عندها فواتير",
  "(new sales interest)": "(اهتمام جديد بكورس)",
  "(select from available interests)": "(اختار من الكورسات المهتم بيها والمتاحة)",
  "Receipt Image": "صورة الإيصال",
  "(for reception to verify)": "(عشان الاستقبال يتحقق)",
  "Sales Manager": "مدير السيلز",
  "Notification Center": "مركز الإشعارات",
  "Critical updates first, then daily actions.": "التحديثات الحرجة الأول، وبعدها الإجراءات اليومية.",
  "Search by client name or phone": "دور باسم العميل أو رقمه",
  "Course Breakdown": "التفاصيل حسب الكورس",
  "Payment Mix": "توزيع طرق الدفع",
  "Focus Queue": "طابور التركيز",
  "Work one lead, log the result, then continue.": "اشتغل على عميل واحد، سجل النتيجة، وبعدها كمّل.",
  "Work now": "اشتغل دلوقتي",
  "Next first touches": "أول تواصل مع العملاء الجايين",
  "Open pipeline": "فتح مراحل البيع",
  "Priority queue": "طابور الأولويات",
  "Upcoming today": "المواعيد الجاية النهارده",
  "Company Target Approvals": "موافقات أهداف الشركة",
  "Policy Tracker": "متابعة السياسات",
  "Commission Rules": "قواعد العمولة",
  "How target progress turns into salesperson and manager bonuses.": "إزاي تحقيق الهدف بيتحسب مكافآت لموظف السيلز والمدير.",
  "Locked for this month": "مقفول للشهر ده",
  "Automatic bonus and penalty decisions grouped by employee.": "قرارات المكافآت والجزاءات التلقائية، متجمعة حسب الموظف.",
  "Target Distribution": "توزيع الهدف",
  "Calculated Bonuses (Commission-Based)": "المكافآت المحسوبة (حسب العمولة)",
  "Total Salesperson Bonuses": "إجمالي مكافآت موظفين السيلز",
  "Edit Commission Tiers": "تعديل شرائح العمولة",
  "Edit Sales Manager Commission": "تعديل عمولة مدير السيلز",
  "Competition Details": "تفاصيل المسابقة",
  "Sales Breakdown by Course": "تفاصيل المبيعات حسب الكورس",
  "Command center could not load the active pipeline snapshot.": "مركز الإدارة مش قادر يحمّل ملخص مراحل البيع النشطة.",
  "No active workload in the current scope.": "مفيش شغل نشط في النطاق الحالي.",
  "No stale or high-intent risk leads.": "مفيش عملاء من غير نشاط أو عملاء اهتمامهم عالي ومعرضين للفقد.",
  "Leads Trend": "تغير أعداد العملاء",
  "Top Performers": "أعلى أداء",
  "Leads by Source": "العملاء حسب المصدر",
  "Revenue Trend": "تغير الإيرادات",
  "No revenue records in selected range": "مفيش سجلات إيرادات في الفترة المختارة",
  "Rep inspection": "مراجعة الموظف",
  "Performance analytics": "تحليل الأداء",
  "Pipeline Status (Open Leads)": "حالات مراحل البيع (العملاء المفتوحين)",
  "Lost Leads Analysis": "تحليل العملاء اللي مش مكملين",
  "Call Outcomes": "نتائج المكالمات",
  "Revenue by Course": "الإيرادات حسب الكورس",
  "Conversions by Course": "التحويلات حسب الكورس",
  "Performance by Source": "الأداء حسب المصدر",
  "Performance by Priority": "الأداء حسب الأولوية",
  "Response Time Distribution": "توزيع وقت الرد",
  "Enrolled Leads Payment Progress": "تقدم دفع العملاء الملتحقين",
  "Team Performance Overview": "ملخص أداء الفريق",
  "Click a rep to inspect status mix, lost reasons, revenue, and source quality.": "اضغط على الموظف عشان تراجع توزيع الحالات وأسباب عدم الاستكمال والإيرادات وجودة المصادر.",
  "Unable to open WhatsApp": "مش قادرين نفتح واتساب",
  "Try again": "جرّب تاني",
  "Opening WhatsApp…": "جاري فتح واتساب…",
  "WhatsApp — {0}": "واتساب — {0}",
  "WhatsApp inbox": "صندوق واتساب",
  "WhatsApp connection": "اتصال واتساب",
  "Opening…": "جاري الفتح…",
  "Connect my number": "ربط رقمي",
  "Manage WhatsApp connection": "إدارة اتصال واتساب",
  "Back to inbox": "رجوع لصندوق الوارد",
  "Any number you connect here is automatically registered under": "أي رقم بتربطه هنا بيتسجل تلقائيًا باسم",
  "your account": "حسابك",
  ". To connect another employee's number, connect it from that employee's account.": ". عشان تربط رقم موظف تاني، اعمل الربط من حساب الموظف ده.",
  "You can see your conversations and those of employees who report to you, based on the direct manager recorded in Arabian.": "بتظهر لك محادثاتك ومحادثات الموظفين التابعين لك حسب المدير المباشر المسجل في أريبيان.",
  "WhatsApp": "واتساب",
  "Unable to open WhatsApp. Try again.": "مش قادرين نفتح واتساب. جرّب تاني.",
  "Unable to open the WhatsApp connection page. Try again.": "مش قادرين نفتح صفحة اتصال واتساب. جرّب تاني.",
};

export const supplementEnglishTranslations: Record<string, string> = {
  "تعذر فتح واتساب": "Unable to open WhatsApp",
  "إعادة المحاولة": "Try again",
  "يتم فتح واتساب…": "Opening WhatsApp…",
  "واتساب — {0}": "WhatsApp — {0}",
  "صندوق واتساب": "WhatsApp inbox",
  "اتصال واتساب": "WhatsApp connection",
  "جارٍ الفتح…": "Opening…",
  "ربط رقمي": "Connect my number",
  "إدارة اتصال واتساب": "Manage WhatsApp connection",
  "العودة لصندوق الوارد": "Back to inbox",
  "أي رقم تربطه هنا يُسجّل تلقائيًا باسم": "Any number you connect here is automatically registered under",
  "حسابك": "your account",
  ". لربط رقم موظف آخر، يتم الربط من حساب ذلك الموظف.": ". To connect another employee's number, connect it from that employee's account.",
  "تظهر لك محادثاتك ومحادثات الموظفين التابعين لك حسب المدير المباشر المسجّل في أريبيان.": "You can see your conversations and those of employees who report to you, based on the direct manager recorded in Arabian.",
  "تعذر فتح واتساب. حاول مرة أخرى.": "Unable to open WhatsApp. Try again.",
  "تعذر فتح صفحة اتصال واتساب. حاول مرة أخرى.": "Unable to open the WhatsApp connection page. Try again.",
};
